export function prospectRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "GET_PROSPECT_START":           
        case "FETCH_PROSPECT_TYPE_START":           
        case "FETCH_PROSPECT_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "GET_PROSPECT_FULFILLED":           
        case "FETCH_PROSPECT_TYPE_FULFILLED":           
        case "FETCH_PROSPECT_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "GET_PROSPECT_ERROR":
        case "FETCH_PROSPECT_TYPE_ERROR":
        case "FETCH_PROSPECT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}